import { render, staticRenderFns } from "./StdCommDiscFactorsReview.vue?vue&type=template&id=f821e5da&"
import script from "./StdCommDiscFactorsReview.vue?vue&type=script&lang=js&"
export * from "./StdCommDiscFactorsReview.vue?vue&type=script&lang=js&"
import style0 from "./StdCommDiscFactorsReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdCommDiscFactorsReview.vue"
export default component.exports